import { types, actions } from './requests'
export const GETJOBTYPELIST_TYPES = {
    ...types('GETJOBTYPELIST'),
}
export const GETJOBTYPELIST_ACTIONS = {
    ...actions('GETJOBTYPELIST'),
}
